import React from 'react';
import Button from '@atlaskit/button';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	isExpanded: boolean;
	label: string;
	onClick: () => void;
};

export const SlackExpandButton = ({ label, isExpanded, onClick }: Props) => {
	// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
	const Chevron = isExpanded ? ChevronDownIcon : ChevronRightIcon;
	const { formatMessage } = useIntl();
	const chevronElement = (
		<Chevron
			size="medium"
			primaryColor={token('color.icon', N500)}
			label={
				isExpanded ? formatMessage(messages.collapseButton) : formatMessage(messages.expandButton)
			}
		/>
	);

	return (
		<Button
			aria-label={label}
			aria-expanded={isExpanded}
			appearance="subtle-link"
			spacing="default"
			iconBefore={chevronElement}
			onClick={onClick}
		/>
	);
};
